import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Controller } from "@hotwired/stimulus";

const CategoriesEditor = lazy(
  () =>
    import("../../components/administration/appointments/categories/CategoriesEditor"),
);

// Connects to data-controller="administration--edit-categories"
export default class extends Controller {
  static values = { context: String, categories: Array };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <Suspense fallback={null}>
        <CategoriesEditor
          context={this.hasContextValue ? this.contextValue : undefined}
          categories={this.categoriesValue}
        />
      </Suspense>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
